/** A version represents one file per relative path. Never turn an ambiguous
 * historical manifest into repeated uploads or deletes.
 */
export function assertUniqueFilePaths(
  files: ReadonlyArray<{ fileName: string }>
): void {
  const paths = new Set<string>();
  for (const file of files) {
    if (paths.has(file.fileName)) {
      throw new Error(
        `The cloud version contains multiple revisions of "${file.fileName}". Refresh the project after the server is updated; do not create another version to resolve this.`
      );
    }
    paths.add(file.fileName);
  }
}
